import React from 'react';
import './Spinner.css';

interface Props {
    visible: boolean;
}

const Spinner: React.FC<Props> = ({ visible = false }) => {
    return (
        <div
            className={`spinner-container${visible ? ' spinner-container--visible' : ''}`}
            aria-hidden={!visible}
            aria-live="polite"
            aria-busy={visible}
        >
            <span className="spinner" />
        </div>
    );
};

export default Spinner;
